import React from 'react';
import { Calendar, Clock, Users, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
interface PackageCardProps {
  id: string;
  title: string;
  image: string;
  duration: string;
  groupSize: string;
  location: string;
  startDate: string;
  price: number;
  description: string;
  featured?: boolean;
}
const PackageCard = ({
  id,
  title,
  image,
  duration,
  groupSize,
  location,
  startDate,
  price,
  description,
  featured = false
}: PackageCardProps) => {
  return <div className={`bg-white rounded-lg shadow-lg overflow-hidden transition-transform hover:-translate-y-1 ${featured ? 'border-2 border-gold-500' : ''}`} data-id="element-490">
      <div className="relative" data-id="element-491">
        <img src={image} alt={title} className="w-full h-48 object-cover" data-id="element-492" />
        {featured && <div className="absolute top-4 right-4 bg-gold-500 text-white px-3 py-1 rounded-full text-sm font-medium" data-id="element-493">
            Featured
          </div>}
      </div>
      <div className="p-6" data-id="element-494">
        <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-495">{title}</h3>
        <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-496">
          <div className="flex items-center text-navy-600" data-id="element-497">
            <Clock size={16} className="mr-2" data-id="element-498" />
            <span className="text-sm" data-id="element-499">{duration}</span>
          </div>
          <div className="flex items-center text-navy-600" data-id="element-500">
            <Users size={16} className="mr-2" data-id="element-501" />
            <span className="text-sm" data-id="element-502">{groupSize}</span>
          </div>
          <div className="flex items-center text-navy-600" data-id="element-503">
            <MapPin size={16} className="mr-2" data-id="element-504" />
            <span className="text-sm" data-id="element-505">{location}</span>
          </div>
          <div className="flex items-center text-navy-600" data-id="element-506">
            <Calendar size={16} className="mr-2" data-id="element-507" />
            <span className="text-sm" data-id="element-508">{startDate}</span>
          </div>
        </div>
        <p className="text-navy-700 mb-4 line-clamp-2" data-id="element-509">{description}</p>
        <div className="flex justify-between items-center" data-id="element-510">
          <div data-id="element-511">
            <span className="text-sm text-navy-600" data-id="element-512">Starting from</span>
            <div className="text-2xl font-bold text-gold-500" data-id="element-513">
              ${price.toLocaleString()}
            </div>
          </div>
          <Link to={`/package/${id}`} className="bg-navy-900 hover:bg-navy-800 text-white px-6 py-2 rounded font-medium transition-colors" data-id="element-514">
            View Details
          </Link>
        </div>
      </div>
    </div>;
};
export default PackageCard;